var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeHalfPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16842 3.26562C8.88784 3.36595 8.61278 3.47747 8.34384 3.59965M5.71954 5.29271C5.48596 5.49754 5.26172 5.71232 5.04751 5.93635M3.25152 8.48866C3.05993 8.8736 2.89198 9.27184 2.74951 9.68157M2.20408 12.4349C2.18118 12.8365 2.18204 13.2459 2.20642 13.6475M2.77371 16.4304C2.91089 16.8158 3.07067 17.1911 3.25152 17.5544M4.96245 20.0167C5.2143 20.2864 5.48052 20.5431 5.7599 20.7856M8.14436 22.3503C8.55106 22.5453 8.97237 22.7156 9.40625 22.8594",
    stroke: "#3B82F6",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.375C18.1954 23.375 22.8125 18.7579 22.8125 13.0625C22.8125 7.36706 18.1954 2.75 12.5 2.75",
    stroke: "#3B82F6",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.6094C13.3543 14.6094 14.0469 13.9168 14.0469 13.0625C14.0469 12.2082 13.3543 11.5156 12.5 11.5156M12.5 14.6094C11.6457 14.6094 10.9531 13.9168 10.9531 13.0625C10.9531 12.2082 11.6457 11.5156 12.5 11.5156M12.5 14.6094V17.1875M12.5 11.5156V6.875",
    stroke: "#3B82F6",
    strokeWidth: 1.6875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeHalfPass);
export default __webpack_public_path__ + "static/media/time-half-pass.06768f222a57ec3e03ccdc4017b0890f.svg";
export { ForwardRef as ReactComponent };